// ─── MOBILE MENU ─────────────────────────────────────────
function openMobileMenu() {
  document.getElementById('solMobileMenu').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  document.getElementById('solMobileMenu').classList.remove('open');
  document.body.style.overflow = '';
}

// ─── TROCA DE IMAGEM (PDP) ───────────────────────────────
function solSwitchImg(src, btn) {
  var img = document.getElementById('solMainImg');
  if (img) {
    img.style.transition = 'opacity 0.2s';
    img.style.opacity = '0';
    setTimeout(function () { img.src = src; img.style.opacity = '1'; }, 200);
  }
  document.querySelectorAll('.sol-thumb').forEach(function(b) { b.classList.remove('active'); });
  if (btn) btn.classList.add('active');
}

// ─── VARIANTE (PDP) ──────────────────────────────────────
function solUpdateVariant(select) {
  var opt = select.options[select.selectedIndex];
  var vid = document.getElementById('solVariantId');
  var priceEl = document.getElementById('solPrice');
  if (vid) vid.value = select.value;
  if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
}

// ─── AJAX ADD TO CART ────────────────────────────────────
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || form.id !== 'solProductForm') return;
  e.preventDefault();

  var btn = document.getElementById('solAddBtn');
  if (!btn) return;
  var orig = btn.textContent;
  btn.textContent = 'ADICIONANDO...';
  btn.disabled = true;

  var variantId = form.querySelector('[name=id]').value;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    btn.textContent = '✓ ADICIONADO';
    setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 2200);
    return fetch('/cart.js');
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var countEl = document.querySelector('.sol-cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
    } else if (cart.item_count > 0) {
      var cartLink = document.querySelector('.sol-cart-link');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'sol-cart-count';
        span.textContent = cart.item_count;
        cartLink.appendChild(span);
      }
    }
  })
  .catch(function() { btn.textContent = orig; btn.disabled = false; });
});

// ─── ANIMAÇÕES DE ENTRADA ────────────────────────────────
function solSetupAnimations() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.sol-fade').forEach(function(el) { el.classList.add('visible'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '-40px' });
  document.querySelectorAll('.sol-fade').forEach(function(el) { obs.observe(el); });
}

// ─── SCROLL NAVBAR ───────────────────────────────────────
function solNavbarScroll() {
  var nav = document.getElementById('solNavbar');
  if (!nav) return;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 80) {
      nav.style.background = 'rgba(0,0,0,0.92)';
    } else {
      nav.style.background = 'transparent';
    }
  }, { passive: true });
}

// ─── INIT ────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  solSetupAnimations();
  solNavbarScroll();
});
